define((require) => {
    const EditBehavior  = require("ui/behaviors/EditBehavior");
    const ImageTagModel = require("ui/assets/image/tags/ImageTagModel");
    const KeyCode       = require("shared/services/KeyCode");
    const Marionette    = require("marionette");
    const template      = require("ui/assets/image/tags/ImageTagItemView.tpl");

    const TAG_NAME_MAX_LENGTH = 80;

    return Marionette.ItemView.extend({

        template,

        tagName: "li",

        className: "image-tag-list-item",

        ui: {
            tagName: ".name"
        },

        events: {
            "keydown @ui.tagName": "_nameKeydownHandler",
            "blur @ui.tagName": "_nameBlurHandler",
            "click .delete": "_deleteClickHandler"
        },

        behaviors: {
            nameEditBehavior: {
                behaviorClass: EditBehavior,
                editFields: [{
                    input: ".name",
                    model: "name",
                    hideIcon: true
                }]
            }
        },

        bindings: {
            ".name": {
                observe: "name",
                updateMethod: "text",
                events: ["blur"]
            }
        },

        modelEvents: {
            "change:name": "_changeNameHandler"
        },

        options: {
            editable: false
        },

        templateHelpers() {
            return {
                editable: this.options.editable
            };
        },

        /**
         * This is really silly.
         * But the way this behaves is that if you change the tag it generally changes to Manual
         * (this includes Amazon Rekognition).
         * However, the ZMAGS_GROUP_ID type should not change even if you change it manually.
         * So we special case the ZMAGS_GROUP_ID.
         *
         * Also we uppercase the name if the type is ZMAGS_GROUP_ID
         */
        _changeNameHandler() {
            if (this.model.get("type")  === ImageTagModel.Types.ZMAGS_GROUP_ID) {
                const upperName = this.model.get("name").toUpperCase();
                this.model.set("name", upperName);
            }
            this.model.set({
                type: (this.model.get("type") === ImageTagModel.Types.ZMAGS_GROUP_ID ? ImageTagModel.Types.ZMAGS_GROUP_ID : ImageTagModel.Types.MANUAL),
                confidence: 100
            }, {silent: true});

            this._updateTagDataType();
        },

        /**
         * The way they do this, any types that are not specifically defined is Amazon Rekognition which is "auto".
         * @private
         */
        _updateTagDataType() {
            var type = "";
            switch (this.model.get("type")) {
                case ImageTagModel.Types.MANUAL:
                    type = "manual";
                    break;
                case ImageTagModel.Types.ZMAGS_GROUP_ID:
                    type = "ZMAGS_GROUP_ID";
                    break;
                default:
                    type = "auto";
            }
            this.$el.attr("data-type", type);
        },

        onBeforeRender() {
            this._updateTagDataType();
        },

        _nameKeydownHandler({keyCode}) {
            const {ENTER, RETURN} = KeyCode;

            if (keyCode === ENTER || keyCode === RETURN) {
                this.ui.tagName.blur();
            }
        },

        _nameBlurHandler() {
            const name = this.ui.tagName.text();
            if (name.length === 0) {
                this._destroy();
            }
        },

        _deleteClickHandler() {
            this._destroy();
        },

        _destroy() {
            const {triggerSource} = this.options;
            this.model.destroy({triggerSource});
        }
    }, {
        TAG_NAME_MAX_LENGTH
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/assets/image/tags/ImageTagItemView.js